export const DSACurriculumSectionData = {
  heading: 'Data Structure and Algorithms track',
  highlightedHeading: '8 weeks',
  topics: [
    'Python',
    'Introduction to Programming',
    'Array',
    'Stings',
    'Big O Notation',
    'Understanding time complexity',
    'Linked Lists',
    'Stacks and Queues',
    'Advanced Sorting and Searching',
    'Trees',
    'Balanced trees and Heaps',
    'Hash tables',
    'Graphs and Graph Algorithms'
  ]
}

export const FrontendCurriculumSectionData = {
  heading: 'Frontend track',
  highlightedHeading: '16 weeks',
  topics: [
    'DSA JS',
    'Javascript Basic',
    'Javascript Advanced',
    'React Basic',
    'React Advanced',
    'NextJS Advanced',
    'Typescript',
    'CSS Advanced'
  ]
}

export const BackendCurriculumSectionData = {
  heading: 'Backend track',
  highlightedHeading: '16 weeks',
  topics: [
    'Node',
    'Express',
    'Javascript Advanced',
    'React Basic',
    'React Advanced',
    'NextJS Advanced',
    'Typescript',
    'CSS Advanced'
  ]
}

export const CurriculumSectionData: {
  [key: string]: {
    heading: string
    highlightedHeading: string
    topics: string[]
  }
} = {
  dsa: DSACurriculumSectionData,
  frontend: FrontendCurriculumSectionData,
  backend: BackendCurriculumSectionData
}
